import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Col, Form, Row } from 'antd';

import { routeFileSelector } from '../../../../../utilz/i18n';
import FormDatePicker from '../../../../components/Inputs/FormDatePicker';
import FormTextArea from '../../../../components/Inputs/FormTextArea';
import FormLabel from '../../../../components/Labels/FormLabel';
import ShipmentStatusSelector from '../../../../components/Selectors/ShipmentStatusSelector';

const QuoteSearch = ({ form }) => {
  const CreatedDateFrom = Form.useWatch('spotQuoteCreatedFrom', form);
  const CreatedDateTo = Form.useWatch('spotQuoteCreateTo', form);

  const ExpShipFrom = Form.useWatch('expectedShipFromDate', form);
  const ExpShipTo = Form.useWatch('expectedShipTodate', form);

  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);
  return (
    <Row className="pt-10">
      <Col sm={24}>
        <FormTextArea
          editMode
          label={t('translation:default.fields.quoteNumberOrTitle.placeholder')}
          placeholder={t('translation:default.fields.quoteNumberOrTitle.placeholder')}
          name="quoteNumber"
          rows={3}
        />
      </Col>

      <Col sm={24}>
        {/* // todo quote */}
        <ShipmentStatusSelector name="quotestatus" mode="multiple" quoteType="search" />
      </Col>
      <Col sm={24}>
        <FormLabel>{t('translation:default.fields.expectedShipDate.label')}</FormLabel>
        <Row className="mt-3 align-items-center" gutter={5}>
          <Col sm={6} className="text-right">
            <FormLabel>{t('translation:default.fields.createdOn.placeholder')}</FormLabel>
          </Col>
          <Col sm={18}>
            <FormDatePicker
              placeholder={t('translation:default.fields.from.label')}
              margin="mb-0"
              name="expectedShipFromDate"
              disableFuture
              disabledTargetDate={ExpShipTo}
              isPrefTzSupport={false}
            />
          </Col>
        </Row>
        <Row className="mt-6 align-items-center" gutter={5}>
          <Col sm={6} className="text-right">
            <FormLabel>{t('translation:default.fields.to.label')} :</FormLabel>
          </Col>
          <Col sm={18}>
            <FormDatePicker
              name="expectedShipTodate"
              placeholder={t('translation:default.fields.createdOn.placeholder')}
              margin="mb-0"
              disableFuture={false}
              disabledTargetDate={ExpShipFrom}
              isPrefTzSupport={false}
            />
          </Col>
        </Row>
      </Col>
      <Col sm={24} className="my-16">
        <FormLabel>{t('translation:default.fields.createdOn.title')}</FormLabel>
        <Row className="mt-3 align-items-center" gutter={5}>
          <Col sm={6} className="text-right">
            <FormLabel>{t('translation:default.fields.from.label')}</FormLabel>
          </Col>
          <Col sm={18}>
            <FormDatePicker
              name="spotQuoteCreatedFrom"
              placeholder={t('translation:default.fields.createdOn.placeholder')}
              margin="mb-0"
              disableFuture
              disabledTargetDate={CreatedDateTo}
              isPrefTzSupport={false}
            />
          </Col>
        </Row>
        <Row className="mt-6 align-items-center" gutter={5}>
          <Col sm={6} className="text-right">
            <FormLabel>{t('translation:default.fields.to.label')} :</FormLabel>
          </Col>
          <Col sm={18}>
            <FormDatePicker
              name="spotQuoteCreateTo"
              placeholder={t('translation:default.fields.createdOn.placeholder')}
              margin="mb-0"
              disableFuture={false}
              disabledTargetDate={CreatedDateFrom}
              isPrefTzSupport={false}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default QuoteSearch;
